import { handleActions } from 'redux-actions';
import { createSelector } from '@reduxjs/toolkit';
import {
  LOAD_RULES_LIST,
  CREATE_RULES,
  EDIT_RULES_BY_ID,
  LOAD_RULES_BY_ID,
  DELETE_RULES,
} from './actions';
import { RULES_MODULE } from '../../configs/moduleNames';
import {
  createLoadListReducerWithBegin,
  createOperationStateReducer,
  updateLoadParameterReducer,
} from '../../utils/getCrudConfig';

const initialState = {
  rulesListMeta: {},
  loadingRulesList: false,
  rulesList: [],
  loadingCurrentRules: false,
  currentRules: {},
  loadingCreateRules: false,
  loadingEditRulesById: false,
  loadingDeleteRules: false,
};

const reducer = handleActions({
  ...createLoadListReducerWithBegin(RULES_MODULE + LOAD_RULES_LIST, 'rulesList', 'loadingRulesList'),
  ...updateLoadParameterReducer(RULES_MODULE + LOAD_RULES_BY_ID, 'currentRules', 'loadingCurrentRules', {}),
  ...createOperationStateReducer(RULES_MODULE + CREATE_RULES, 'loadingCreateRules'),
  ...createOperationStateReducer(RULES_MODULE + EDIT_RULES_BY_ID, 'loadingEditRulesById'),
  ...createOperationStateReducer(RULES_MODULE + DELETE_RULES, 'loadingDeleteRules'),
}, initialState);

export default reducer;

export const getRulesData = createSelector(
  [state => state[RULES_MODULE]],
  state => {
    const {
      rulesListMeta,
      loadingRulesList,
      rulesList,
      loadingCurrentRules,
      currentRules,
      loadingCreateRules,
      loadingEditRulesById,
      loadingDeleteRules,
    } = state;
    return {
      rulesListMeta,
      loadingRulesList,
      rulesList,
      loadingCurrentRules,
      currentRules,
      loadingCreateRules,
      loadingEditRulesById,
      loadingDeleteRules,
    };
  },
);
